import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Switch,
} from "antd";
import { Card, Image } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConfig, updateConfig, setConfig } from "../slice";
import { Select, Space } from "antd";
import DebounceSelect from "components/common/DebounceSelect";
import commonApi from "utils/api";
import configApi from "../api";
import { getPhotoThumbnailUrl, getPhotoUrl } from "utils/common";
import { Upload, message } from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import CustomModuleItemsList from "../components/CustomModuleItemsList";

export default function SystemConfig() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { config, isLoading } = useSelector((state) => state.config);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [removeImageIds, setRemoveImageIds] = useState([]);

  const handleChangeUploadFiles = ({ fileList }) => {
    setUploadFileList(fileList);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Chọn ảnh</div>
    </div>
  );

  useEffect(() => {
    dispatch(fetchConfig());
  }, [dispatch]);

  useEffect(() => {
    const transfer = {
      enable: config.transfer?.enable || false,
      maxAmount: config.transfer?.maxAmount || 500000,
      maxCountPerDay: config.transfer?.maxCountPerDay || 3,
    };
    const freeVouchers = {
      bestGoka: config.freeVouchers?.bestGoka,
      newUser: config.freeVouchers?.newUser,
      newUserFrom: config.freeVouchers?.newUserFrom
        ? dayjs(config.freeVouchers?.newUserFrom)
        : null,
    };
    const modules = {
      foodActive: config.modules?.foodActive || false,
      foodAlert: config.modules?.foodAlert || "",
      bikeActive: config.modules?.bikeActive || false,
      bikeAlert: config.modules?.bikeAlert || "",
      expressActive: config.modules?.expressActive || false,
      expressAlert: config.modules?.expressAlert || "",
      driverActive: config.modules?.driverActive || false,
      driverAlert: config.modules?.driverAlert || "",
    };
    const ads = {
      homeBannerCount: config.ads?.homeBannerCount || 1,
      searchBannerCount: config.ads?.searchBannerCount || 1,
      searchListCount: config.ads?.searchListCount || 1,
      campaignListCount: config.ads?.campaignListCount || 1,
      categoryListCount: config.ads?.categoryListCount || 1,
    };
    const contact = {
      text: config.contact?.text || "Chat với GOKA qua Zalo",
      link: config.contact?.link || "http://zalo.me/0792339233",
    };
    const { categoryHasVoucher, campaignFreeShip } = config;
    const customModule = {
      active: config.customModule?.active || false,
      images: config.customModule?.images || [],
      type: config.customModule?.type || "null",
      url: config.customModule?.url || "",
      openBrowser: config.customModule?.openBrowser || false,
      restaurant: config.customModule?.restaurant || undefined,
      title: config.customModule?.title || "",
    };

    // Set existing images for display
    setExistingImages(config.customModule?.images || []);
    setRemoveImageIds([]); // Reset remove list when config changes
    form.setFieldsValue({
      transfer,
      freeVouchers,
      categoryHasVoucher,
      campaignFreeShip,
      modules,
      ads,
      contact,
      customModule,
    });
  }, [config]);

  const onFinish = async (config) => {
    // If no file operations, use regular update
    if (uploadFileList.length === 0 && removeImageIds.length === 0) {
      dispatch(updateConfig({ ...config }));
    } else {
      // Use FormData for file operations
      const formData = new FormData();

      // Add new images if any
      if (uploadFileList.length > 0) {
        uploadFileList.forEach((file) => {
          if (file.originFileObj) {
            formData.append("images", file.originFileObj);
          }
        });
      }

      // Add removeImageIds if any
      if (removeImageIds.length > 0) {
        formData.append("removeImageIds", JSON.stringify(removeImageIds));
      }

      // Add all config data as individual form fields
      Object.keys(config).forEach((key) => {
        if (typeof config[key] === "object" && config[key] !== null) {
          formData.append(key, JSON.stringify(config[key]));
        } else {
          formData.append(key, config[key]);
        }
      });

      try {
        const response = await configApi.updateConfigWithFiles(formData);
        if (response.error) {
          message.error(response.error.msg);
        } else {
          dispatch(setConfig(response.data));
          message.success("Cập nhật cấu hình thành công!");
          setUploadFileList([]);
          setRemoveImageIds([]);
        }
      } catch (err) {
        console.log(err);
        message.error("Không thể cập nhật cấu hình!");
      }
    }
  };

  return (
    <>
      <Form
        name="basic"
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        style={{ maxWidth: 1200 }}
        autoComplete="off"
        onFinish={onFinish}
      >
        <Divider orientation="left">Cấu hình module</Divider>
        <Form.Item
          label="GOKA Food"
          name={["modules", "foodActive"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Thông báo khi tắt GOKA Food"
          name={["modules", "foodAlert"]}
        >
          <Input placeholder="Nhập nội dung thông báo khi tắt GOKA Food" />
        </Form.Item>
        <Form.Item
          label="GOKA Bike"
          name={["modules", "bikeActive"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Thông báo khi tắt GOKA Bike"
          name={["modules", "bikeAlert"]}
        >
          <Input placeholder="Nhập nội dung thông báo khi tắt GOKA Bike" />
        </Form.Item>
        <Form.Item
          label="GOKA Giao hàng"
          name={["modules", "expressActive"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Thông báo khi tắt GOKA Giao hàng"
          name={["modules", "expressAlert"]}
        >
          <Input placeholder="Nhập nội dung thông báo khi tắt GOKA Giao hàng" />
        </Form.Item>
        <Form.Item
          label="GOKA BSTL"
          name={["modules", "driverActive"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Thông báo khi tắt GOKA BSTL"
          name={["modules", "driverAlert"]}
        >
          <Input placeholder="Nhập nội dung thông báo khi tắt GOKA BSTL" />
        </Form.Item>
        <Divider orientation="left">Module tuỳ biến</Divider>
        <Form.Item
          label="Kích hoạt"
          name={["customModule", "active"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item label="Ảnh hiển thị">
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>
            {/* Existing Images */}
            {existingImages.length > 0 && (
              <div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {existingImages.map((imageId, index) => (
                    <div
                      key={imageId?._id || imageId || index}
                      style={{
                        position: "relative",
                        border: removeImageIds.includes(imageId?._id || imageId)
                          ? "2px solid #ff4d4f"
                          : "1px solid #d9d9d9",
                        borderRadius: 6,
                        overflow: "hidden",
                        opacity: removeImageIds.includes(
                          imageId?._id || imageId
                        )
                          ? 0.5
                          : 1,
                      }}
                    >
                      <Image
                        width={198}
                        height={100}
                        src={getPhotoUrl(imageId?.path || imageId)}
                        alt="image"
                        style={{ objectFit: "cover" }}
                      />

                      <Button
                        type="primary"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        style={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          width: 24,
                          height: 24,
                          minWidth: 24,
                          padding: 0,
                        }}
                        onClick={() => {
                          const actualImageId = imageId?._id || imageId;
                          if (removeImageIds.includes(actualImageId)) {
                            // Remove from delete list
                            setRemoveImageIds((prev) =>
                              prev.filter((id) => id !== actualImageId)
                            );
                          } else {
                            // Add to delete list
                            setRemoveImageIds((prev) => [
                              ...prev,
                              actualImageId,
                            ]);
                          }
                        }}
                      />
                      {removeImageIds.includes(imageId?._id || imageId) && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(255, 77, 79, 0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            color: "#ff4d4f",
                            fontWeight: 500,
                          }}
                        >
                          Sẽ xóa
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* New Images Upload */}
            <div>
              <Upload
                accept={"image/*"}
                multiple
                listType="picture-card"
                className="avatar-uploader-cover"
                fileList={uploadFileList}
                onChange={handleChangeUploadFiles}
                beforeUpload={() => false}
              >
                {uploadButton}
              </Upload>
            </div>
          </div>
        </Form.Item>
        <Form.Item label="Loại" name={["customModule", "type"]}>
          <Select placeholder="--Chọn loại--">
            <Select.Option value="null">Không dùng</Select.Option>
            <Select.Option value="list">Danh sách</Select.Option>
            <Select.Option value="url">Liên kết</Select.Option>
            <Select.Option value="restaurant">Nhà hàng</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev?.customModule?.type !== cur?.customModule?.type
          }
        >
          {({ getFieldValue }) => {
            const type = getFieldValue(["customModule", "type"]);
            if (type === "null") return null;
            if (type === "url") {
              return (
                <>
                  <Form.Item label="URL" name={["customModule", "url"]}>
                    <Input placeholder="https://..." />
                  </Form.Item>
                  <Form.Item
                    label="Mở bằng trình duyệt"
                    name={["customModule", "openBrowser"]}
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </>
              );
            }
            if (type === "restaurant") {
              return (
                <>
                  <Form.Item
                    label="ID nhà hàng"
                    name={["customModule", "restaurant"]}
                  >
                    <Input placeholder="Nhập ID nhà hàng" />
                  </Form.Item>
                </>
              );
            }
            if (type === "list") {
              return (
                <>
                  <Form.Item label="Tiêu đề" name={["customModule", "title"]}>
                    <Input placeholder="Nhập tiêu đề danh sách" />
                  </Form.Item>
                  <Form.Item label="Danh sách items">
                    <CustomModuleItemsList />
                  </Form.Item>
                </>
              );
            }
            return null;
          }}
        </Form.Item>
        <Divider orientation="left">Chi hộ</Divider>
        <Form.Item
          label="Bật chi hộ"
          name={["transfer", "enable"]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Số lần chi hộ tối đa /1 ngày"
          name={["transfer", "maxCountPerDay"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Số tiền chi hộ tối đa /1 giao dịch"
          name={["transfer", "maxAmount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <br />
        <Divider orientation="left">Tặng voucher Best GOKA</Divider>
        <br />
        <Form.Item
          label="ID Voucher tặng"
          name={["freeVouchers", "bestGoka"]}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập ID Voucher Best GOKA" />
        </Form.Item>
        <br />
        <Divider orientation="left">Tặng voucher cho khách đăng ký mới</Divider>
        <br />
        <Form.Item
          name={["freeVouchers", "newUserFrom"]}
          label="Từ ngày"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            placeholder={"Ngày khách đăng ký mới được tặng voucher"}
          />
        </Form.Item>
        <Form.Item
          label="ID Voucher tặng"
          name={["freeVouchers", "newUser"]}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập ID Voucher tặng khách đăng ký mới" />
        </Form.Item>
        <br />
        <Divider orientation="left">Danh mục khuyến mãi</Divider>
        <br />
        <Form.Item
          label="ID danh mục"
          name={"categoryHasVoucher"}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập ID danh mục khuyến mãi" />
        </Form.Item>
        <br />
        <Divider orientation="left">Chiến dịch freeship</Divider>
        <br />
        <Form.Item
          label="ID chiến dịch"
          name={"campaignFreeShip"}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập ID chiến dịch freeship" />
        </Form.Item>
        <br />
        <Divider orientation="left">Quảng cáo</Divider>
        <br />
        <Form.Item
          label="Số lượng banner trang chủ"
          name={["ads", "homeBannerCount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Số lượng banner trang tìm kiếm"
          name={["ads", "searchBannerCount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Số lượng quán gợi ý trang tìm kiếm"
          name={["ads", "searchListCount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Số lượng quán gợi ý trang chiến dịch"
          name={["ads", "campaignListCount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Số lượng quán gợi ý trang danh mục"
          name={["ads", "categoryListCount"]}
        >
          <InputNumber min={0} />
        </Form.Item>
        <Divider orientation="left">Liên hệ</Divider>
        <br />
        <Form.Item label="Nội dung hiển thị" name={["contact", "text"]}>
          <Input placeholder="Nhập nội dung hiển thị" />
        </Form.Item>
        <Form.Item label="Liên kết" name={["contact", "link"]}>
          <Input placeholder="Nhập liên kết liên hệ" />
        </Form.Item>
      </Form>

      {/* Floating Update Button */}
      <Button
        type="primary"
        size="large"
        loading={isLoading}
        onClick={() => form.submit()}
        icon={<SaveOutlined />}
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
          borderRadius: 32,
          height: 48,
          paddingLeft: 24,
          paddingRight: 24,
          fontSize: 16,
          fontWeight: 500,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        Cập nhật
      </Button>
    </>
  );
}
